// extracted by mini-css-extract-plugin
export const root = "g_c";
export const text = "g_d";
export const video = "g_f";
export const button = "g_g";